import * as service from './service'
import toast from '@flashex-fe-comp/issdesign/lib/toast'
import { bdCommonTrack } from '@/utils/bdCourier'
export default {
  namespace: 'order',
  state: {
    orderData: []
  },
  effects: {
    * getOrderList ({ payload }, { call, put }) {
      try {
        const res = yield call(service.getOrderList, payload)
        const { data } = res
        if (data.status === 200) {
          // bdCommonTrack('order_data_observe', {
          //     event_type: 'view',
          //     res: JSON.stringify(res)
          // })
          yield put({ type: 'save', payload: { orderData: data.data } })
          return data.data
        } else {
          // bdCommonTrack('order_data_observe', {
          //     event_type: 'view',
          //     res: JSON.stringify(res)
          // })
          toast(data.err || '发生网络错误')
          return Promise.reject()
        }
      } catch (error) {
        toast('发生网络错误')
      }
    },
    * orderConfig ({ payload }, { call, put }) {
      try {
        const res = yield call(service.orderConfig, payload)
        const { data } = res
        if (data.status === 200) {
          // bdCommonTrack('order_config_observe', {
          //     event_type: 'view',
          //     res: JSON.stringify(res)
          // })
          return data.data
        } else {
          // bdCommonTrack('order_config_observe', {
          //     event_type: 'view',
          //     res: JSON.stringify(res)
          // })
          toast(data.err || '发生网络错误')
          return Promise.reject()
        }
      } catch (error) {
        toast('发生网络错误')
      }
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
